var $03ad7cde4af17dbc$exports = {};
$03ad7cde4af17dbc$exports = {
    "Empty": `\u{5E8}\u{5D9}\u{5E7}`
};


export {$03ad7cde4af17dbc$exports as default};
//# sourceMappingURL=he-IL.mjs.map
